import { render } from "./RoleUserForm.vue?vue&type=template&id=349a0a1f&ts=true"
import script from "./RoleUserForm.vue?vue&type=script&lang=ts"
export * from "./RoleUserForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__